import React, { forwardRef, useState, useEffect } from 'react'
import { NumberInput, Checkbox, Select } from '@mantine/core'
import { DtMedia } from '@ow/ditto-core'
import BasicSettings from '../components/BasicSettings'
import TitleComp from '../components/Title'
import CheckComp from '../components/Check'
import { fileSizeList } from './config'

const { config } = DtMedia

const Render = (props) => {
  const { watch, reset, register, getValues, control, Controller } = props
  const [fileSizeVisible, setFileSizeVisible] = useState(false)
  const fileTypeMap = getValues('fileTypeMap') || config.fileTypeMap
  useEffect(() => {
    // 设置默认类型，如果全部未选中，则默认选中第一个。
    const isAllUnChecked = fileTypeMap.every(
      (fileItem) => !getValues(fileItem.type)
    )
    if (isAllUnChecked && fileTypeMap.length) {
      const { type = '', typeList = [] } = fileTypeMap[0]
      const allowedTypes = getValues('allowedTypes')
      if (type) {
        reset({
          ...getValues(),
          [type]: true,
          allowedTypes:
            allowedTypes && allowedTypes.length > 0 ? allowedTypes : typeList,
        })
      }
    }
  }, [getValues('title')])
  return (
    <BasicSettings register={register}>
      <TitleComp title="上传文件类型">
        {fileTypeMap.map((fileTypeItem, index) => {
          return (
            <>
              <CheckComp
                register={register}
                registerName={fileTypeItem.type}
                label={fileTypeItem.label}
                checked={getValues(fileTypeItem.type)}
                onChange={(e) => {
                  const { checked } = e.currentTarget
                  const selecctFileTypeList = fileTypeMap[index].typeList
                  if (checked) {
                    reset({
                      ...getValues(),
                      [fileTypeItem.type]: checked,
                      allowedTypes: [
                        ...getValues('allowedTypes'),
                        ...selecctFileTypeList,
                      ],
                    })
                  } else {
                    reset({
                      ...getValues(),
                      [fileTypeItem.type]: checked,
                      allowedTypes: [
                        ...getValues('allowedTypes').filter(
                          (fileType) => !selecctFileTypeList.includes(fileType)
                        ),
                      ],
                    })
                  }
                }}
              />
              {watch(fileTypeItem.type) && (
                <Controller
                  name="allowedTypes"
                  control={control}
                  render={({ field }) => {
                    return (
                      <Checkbox.Group
                        size="xs"
                        {...field}
                        defaultValue={getValues('allowedTypes')}
                        onChange={(value) => {
                          reset({ ...getValues(), allowedTypes: value })
                        }}
                      >
                        {fileTypeItem.typeList.map((type) => {
                          return (
                            <Checkbox
                              key={`filetype-${type}`}
                              value={type}
                              label={type}
                            />
                          )
                        })}
                      </Checkbox.Group>
                    )
                  }}
                />
              )}
            </>
          )
        })}
      </TitleComp>
      <TitleComp title="单个文件上传体积">
        <Controller
          name="maxSize"
          control={control}
          render={() => {
            return (
              <Select
                defaultValue={getValues('maxSize')}
                onChange={(value) => {
                  if (value === 'other') {
                    setFileSizeVisible(true)
                  } else {
                    setFileSizeVisible(false)
                    reset({ ...getValues(), maxSize: value })
                  }
                }}
                data={fileSizeList}
              />
            )
          }}
        />
        {fileSizeVisible && (
          <Controller
            name="maxSize"
            control={control}
            render={({ field }) => {
              return (
                <NumberInput
                  style={{ marginTop: '10px' }}
                  {...field}
                  step={0.01}
                  precision={2}
                  placeholder="请填入单个文件体积"
                  min={0.01}
                  max={500.0}
                />
              )
            }}
          />
        )}
      </TitleComp>
      <TitleComp title="支持上传数量">
        <Controller
          name="uploadQuantities"
          control={control}
          render={({ field }) => {
            return (
              <NumberInput
                {...field}
                placeholder="请填入上传文件个数"
                min={1}
                max={50}
                defaultValue={getValues('uploadQuantities') || 20}
              />
            )
          }}
        />
      </TitleComp>
      <TitleComp title="校验">
        <CheckComp
          register={register}
          registerName="required"
          // defaultValue={require}
          label="必填项：至少上传一个文件"
        />
      </TitleComp>
    </BasicSettings>
  )
}

export default forwardRef(Render)
